export const BasicReducerConstants={
    OPEN_SIDEBAR:'OPEN_SIDEBAR',
    CLOSE_SIDEBAR:'CLOSE_SIDEBAR'
}

export const AuthConstants={
    LOGIN_REQUEST:'LOGIN_REQUEST',
    LOGIN_SUCCESS:'LOGIN_SUCCESS',
    LOGIN_FAILURE:'LOGIN_FAILURE',

    LOGOUT_REQUEST:'LOGOUT_REQUEST',
    LOGOUT_SUCCESS:'LOGOUT_SUCCESS',
    LOGOUT_FAILURE:'LOGOUT_FAILURE',

    SIGNUP_REQUEST:'SIGNUP_REQUEST',
    SIGNUP_SUCCESS:'SIGNUP_SUCCESS',
    SIGNUP_FAILURE:'SIGNUP_FAILURE',
}

export const ExpensesConstants={
    CREATE_EXPENSE_REQUEST:'CREATE_EXPENSE_REQUEST',
    CREATE_EXPENSE_SUCCESS:'CREATE_EXPENSE_SUCCESS',
    CREATE_EXPENSE_FAILURE:'CREATE_EXPENSE_FAILURE',

    EDIT_EXPENSE_REQUEST:'EDIT_EXPENSE_REQUEST',
    EDIT_EXPENSE_SUCCESS:'EDIT_EXPENSE_SUCCESS',
    EDIT_EXPENSE_FAILURE:'EDIT_EXPENSE_FAILURE',

    GET_EXPENSES_REQUEST:'GET_EXPENSES_REQUEST',
    GET_EXPENSES_FAILURE:'GET_EXPENSES_FAILURE',
    GET_EXPENSES_SUCCESS:'GET_EXPENSES_SUCCESS',
    GET_EXPENSES_SUCCESS_EMPTY:'GET_EXPENSES_SUCCESS_EMPTY',

    SET_CURRENT_EXPENSE:'SET_CURRENT_EXPENSE',
    RESET_EXPENSES_REDUCER:'RESET_EXPENSES_REDUCER',
}

export const UserConstants={
    EDIT_REQUEST:'EDIT_REQUEST',
    EDIT_SUCCESS:'EDIT_SUCCESS',
    EDIT_FAILURE:'EDIT_FAILURE'
}

export const GeneralDataConstants={
    CALCULATE_REQUEST:'CALCULATE_REQUEST',
    INITIAL_CALCULATE_DATA:'INITIAL_CALCULATE_DATA',
    INITIAL_CALCULATE_DATA_EMPTY:'INITIAL_CALCULATE_DATA_EMPTY',
    ADDED_NEW_EXPENSE:'ADDED_NEW_EXPENSE',
    EDITED_EXPENSE:'EDITED_EXPENSE',
    CALCULATION_COMPLETE:'CALCULATION_COMPLETE',
    CLEAR_DATA:'CLEAR_DATA'
}